var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { SortSelect } from './Controls';
import { Card, EmptyCard } from './Card';
import { StyledTableCardList } from './styles';
import { LoadMoreButton } from '../shared';
import { Caption } from '../shared/Caption';
const headingLevelMap = {
    h1: 'h2',
    h2: 'h3',
    h3: 'h4',
    h4: 'h5',
    h5: 'h6',
};
const CardListVariantRefForwardingComponent = (_a, ref) => {
    var _b, _c, _d;
    var { tableInstance, cardList, shared, headingRef } = _a, others = __rest(_a, ["tableInstance", "cardList", "shared", "headingRef"]);
    const { current: captionId } = useRef(uuidv4());
    const { rows, prepareRow } = tableInstance;
    const { getSortOptionsCardListHeader } = cardList;
    // The filter fixes a bug where react-table includes the expanded row's children as
    // part of the row[], causing the parent row to be rendered an additional time per child.
    // Expanded rows have a row.depth of 1, so we filter out rows that have a row depth of 1 or greater.
    const data = tableInstance.page
        ? tableInstance.page
        : rows.filter(row => row.depth < 1);
    const paginationInformation = shared.pagination
        ? `Page ${tableInstance.state.pageIndex + 1} of ${tableInstance.pageCount}`
        : undefined;
    return (React.createElement(StyledTableCardList, { "$disableContainer": shared.disableContainer, "$colCount": cardList.colCount || '2', "data-testid": "mui-table-cardlist-section", "aria-labelledby": captionId },
        React.createElement(Caption, { variant: "cardList", text: shared.captionText, size: (_b = cardList.caption) === null || _b === void 0 ? void 0 : _b.size, isVisible: !!((_c = cardList.caption) === null || _c === void 0 ? void 0 : _c.isVisible), headingLevel: cardList.caption.headingLevel, ref: headingRef, paginationInformation: paginationInformation, captionId: captionId }),
        React.createElement(SortSelect, { tableInstance: tableInstance, getSortOptionsCardListHeader: getSortOptionsCardListHeader, handleManualSort: shared.handleManualSort }),
        React.createElement("ul", Object.assign({ ref: ref }, others, { "data-testid": "mui-table-cardlist" }), data.length ? (data.map((row, index) => {
            var _a;
            prepareRow(row);
            return (React.createElement(Card, { key: row.id, row: row, cardIndex: index, headingLevel: headingLevelMap[cardList.caption.headingLevel], hiddenColumns: cardList.hiddenColumns, isFocused: ((_a = shared.loadMoreValues) === null || _a === void 0 ? void 0 : _a.newRowIndex) === row.index, isLoading: shared.isLoading }));
        })) : (React.createElement(EmptyCard, { isLoading: shared.isLoading }))),
        !shared.isLoading && !!((_d = shared.loadMoreValues) === null || _d === void 0 ? void 0 : _d.canShowMore) && (React.createElement(LoadMoreButton, { loadMoreValues: shared.loadMoreValues, mt: "md" }))));
};
const CardListVariant = React.forwardRef(CardListVariantRefForwardingComponent);
export { CardListVariant };
//# sourceMappingURL=CardListVariant.js.map